import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import AboutUs from "./pages/AboutUs";
import ClassroomTraining from "./pages/ClassroomTraining";
import OnlineTraining from "./pages/OnlineTraining";
import Contact from "./pages/Contact";
import AICourse from "./pages/AICourse";
import DataEngineer from "./pages/DataEngineer";
import JavaFullStack from "./pages/JavaFullStack";
import PythonFullStack from "./pages/PythonFullStack";
import DataAnalysis from "./pages/DataAnalysis";
import Register from "./pages/Register";
import JobOpenings from "./pages/JobOpenings";
import PlacedCandidates from "./pages/PlacedCandidates";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/classroom" element={<ClassroomTraining />} />
        <Route path="/online" element={<OnlineTraining />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ai" element={<AICourse />} />
        <Route path="/data-engineer" element={<DataEngineer />} />
        <Route path="/java" element={<JavaFullStack />} />
        <Route path="/python-fullstack" element={<PythonFullStack />} />
        <Route path="/data-analysis" element={<DataAnalysis />} />
        <Route path="/register" element={<Register />} />
        <Route path="/job-openings" element={<JobOpenings />} />
        <Route path="/placed-candidates" element={<PlacedCandidates />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
